"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _backbone = _interopRequireDefault(require("backbone"));

var _underscore = _interopRequireDefault(require("underscore"));

var _config = _interopRequireDefault(require("config"));

var _FieldValue = _interopRequireDefault(require("./FieldValue"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FieldValueCollection = _backbone.default.Collection.extend({
  model: _FieldValue.default,
  initialize: function initialize() {
    this.listenTo(this, 'add reset remove', this.updateModelsIndex);
  },
  updateModelsIndex: function updateModelsIndex() {
    var thisModel = this;

    _underscore.default.each(this.models, function (field) {
      field.set('position', thisModel.indexOf(field));
    });
  }
});

var _default = FieldValueCollection;
exports.default = _default;